// REPOST
import { format } from 'date-fns';
import { useMemo } from 'react';

import { useTransformScale } from '../useTransformScale';
import { IActions, IEntregador, IPeriodo } from './index.d';
import { useToggleActiveRecieveCollect } from '../useToggleActiveRecieveCollect';
import { useToggleTypeCollect } from '../useToggleTypeCollect';
import { useTogglePossuiBau } from '../useTogglePossuiBau';
import { useToggleEntrarEscala } from '../useToggleEntrarEscala';
//turno={props.variables.filter.turno}
export const useTransformPlayer = (
    entregadores: IEntregador[] = [],
    actions: IActions,
    periodos?: IPeriodo[],
    turno?: 'Café' | 'Almoço' | 'Janta' // props.variables.filter.turno
) => {
    const { handleToogleRecieveCollect } = useToggleActiveRecieveCollect();
    const { handleToogleTypeCollect } = useToggleTypeCollect();
    const { handleTogglePossuiBau } = useTogglePossuiBau();
    const { handleToggleEntrarEscala } = useToggleEntrarEscala();
    const { handleTransformScale } = useTransformScale(periodos, turno);
    const data = useMemo(() => {
        return entregadores?.map((entregador) => {
            let lineClassName = '';
            let ativo = false;

            switch (entregador.status) {
                case 'inativo':
                    lineClassName = 'bgRed';
                    break;
                case 'pendente':
                    lineClassName = 'bgOrange';
                    break;
                default:
                    ativo = true;
            }

            const dataCadastro = format(
                new Date(entregador.dataCadastro),
                'dd/MM/yyyy'
            );

            return {
                lineClassName,
                colunas: [
                    {
                        status: entregador.status,
                        tipo: 'Texto',
                        width: 'minmax(25rem, 35rem)',
                        marginRight: '1rem',
                        titulo: entregador.nomeCompleto,
                        subtitulo: entregador.telefone,
                        descricao: entregador.email,
                        flexDirection: 'row',
                    },
                    {
                        tipo: 'Texto',
                        temaBotao: '2',
                        width: '13rem',
                        marginRight: '1.5rem',
                        titulo: dataCadastro,
                    },
                    {
                        tipo: 'Texto',
                        temaBotao: '2',
                        width: '8rem',
                        marginRight: '1.5rem',
                        titulo: entregador?.appVersion || '',
                    },
                    entregador.typeScale === 'scale' && {
                        tipo: 'Texto',
                        temaBotao: '2',
                        width: 'minmax(26rem, 1fr)',
                        marginRight: '1.5rem',
                        titulo: '',
                        subtitulo: '',
                        flexWrap: 'wrap',
                        botoesInline: handleTransformScale(entregador),
                    } || {
                        tipo: 'Texto',
                        temaBotao: '2',
                        width: 'minmax(26rem, 1fr)',
                        marginRight: '0',
                        titulo: '',
                        subtitulo: '',
                    },
                    {
                        tipo: 'Texto',
                        width: '15rem',
                        titulo: entregador.machineCode ? 'Possui maquina JR' : '',
                        flexDirection: 'row',
                        botoesInline: [
                            {
                                titulo: entregador.recebeColeta
                                    ? 'Recebe coleta'
                                    : 'Nao recebe coleta',
                                icone: !entregador.recebeColeta ? 'icon-deslike' : 'icon-like',
                                color: !entregador.recebeColeta ? 'red' : 'green',
                                click: () => {
                                    handleToogleRecieveCollect({
                                        entregadorId: entregador.id,
                                        recebeColeta: entregador.recebeColeta ? false : true,
                                    });
                                },
                            },
                        ],
                    },
                    {
                        tipo: 'Texto',
                        width: '15rem',
                        titulo: '',
                        flexDirection: 'row',
                        botoesInline: [
                            {
                                titulo: entregador.podeEntrarEscala
                                    ? 'Pode entrar na disponibilidade'
                                    : 'Nao pode entrar na disponibilidade',
                                icone: !entregador.podeEntrarEscala ? 'icon-deslike' : 'icon-like',
                                color: !entregador.podeEntrarEscala ? 'red' : 'green',
                                click: () => {
                                    handleToggleEntrarEscala({
                                        entregadorId: entregador.id,
                                        podeEntrarEscala: entregador.podeEntrarEscala ? false : true,
                                    });
                                },
                            },
                        ],
                    },
                    {
                        tipo: 'Texto',
                        width: '15rem',
                        titulo: '',
                        flexDirection: 'row',
                        botoesInline: [
                            {
                                titulo: entregador.possuiBau
                                    ? 'Possui baú'
                                    : 'Não possui baú',
                                icone: !entregador.possuiBau ? 'icon-deslike' : 'icon-like',
                                color: !entregador.possuiBau ? 'red' : 'green',
                                click: () => {
                                    handleTogglePossuiBau({
                                        entregadorId: entregador.id,
                                        possuiBau: entregador.possuiBau ? false : true,
                                    });
                                },
                            },
                        ],
                    },
                    {
                        tipo: 'Texto',
                        width: '25rem',
                        titulo: '',
                        temaBotao: '2',
                        botoesInline: [
                            {
                                titulo: 'Nuvem',
                                icone: 'icon-click-like',
                                status: entregador.typeScale === 'cloud' ? 'ativo' : '',
                                click: () => {
                                    handleToogleTypeCollect({
                                        entregadorId: entregador.id,
                                        typeScale: 'cloud',
                                    });
                                },
                            },
                            {
                                titulo: 'Disponibilidade',
                                icone: 'icon-click-like',
                                status: entregador.typeScale === 'scale' ? 'ativo' : '',
                                click: () => {
                                    handleToogleTypeCollect({
                                        entregadorId: entregador.id,
                                        typeScale: 'scale',
                                    });
                                },
                            },
                        ],
                    },
                    {
                        tipo: 'Texto',
                        titulo: '',
                        subtitulo: '',
                        width: '17rem',
                        marginRight: '0',
                        botoes: [
                            {
                                titulo: `Seu modal é "${
                                    entregador.modalTransporteNome || 'Moto'
                                }". Clique para trocar de modal de transporte`,
                                click: actions.handleToogleModalTransporte,
                                data: {
                                    entregadorId: entregador.id,
                                    modalTransporteId:
                                        entregador.modalTransporteId,
                                },
                                icone:
                                    entregador.modalTransporteId === 2
                                        ? 'icon-carro'
                                        : 'icon-moto',
                            },
                            {
                                titulo: 'Inserir ou alterar os dados bancários',
                                click: actions.handleDataBackPlayer,
                                data: { entregadorId: entregador.id },
                                icone: 'icon-casa-moeda',
                            },
                            {
                                titulo: 'Relatório financeiro',
                                click: actions.handleReportPlayer,
                                data: { entregadorId: entregador.id },
                                icone: 'icon-ajustar',
                            },
                            {
                                titulo: ativo
                                    ? 'Entregador ativo'
                                    : 'Entregador inativo',
                                click: actions.handleToogleActive,
                                data: {
                                    entregadorId: entregador.id,
                                    ativo,
                                },
                                icone: ativo
                                    ? 'icon-visualizar'
                                    : 'icon-naovisualizar',
                            },
                            {
                                titulo: 'Editar dados do entregador',
                                click: actions.handleEditPlayer,
                                data: { entregadorId: entregador.id },
                                icone: 'icon-editar',
                            },
                            {
                                titulo: 'Validar Documentos',
                                click: actions.handleValidateDocument,
                                data: { entregadorId: entregador.id },
                                icone: 'icon-ajuste',
                            },
                        ],
                    },
                ],
            };
        });
    }, [entregadores]);

    return data;
};
